export default function(object)
{
	const lines = []

	object.label && lines.push(object.label)
	object.address && lines.push(object.address)
	object.address2 && lines.push(object.address2)
	object.address3 && lines.push(object.address3)

	if ( object.city || object.state || object.region || object.postal_code || object.zip )
	{
		let line = []

		object.city && line.push(object.city)
		object.state && line.push(object.state)
		object.region && line.push(object.region)

		line.length && ( line = [ line.join(', ') ] )

		object.postal_code && line.push(object.postal_code)

		if (object.zip && object.zip != object.postal_code)
		{
			line.push(object.zip)
		}

		lines.push(line.join(' '))
	}

	return lines
}